import { Container } from '@mantine/core';
import { Editor } from '../components/Editor';
import { EditorPanel } from '../components/EditorPanel';
import { ItemsList } from '../components/ItemsList';
import { Toolbar } from '../components/Toolbar';
import { useThumbnailMaker } from '../hooks/useThumbnailMaker';

/**
 * ThumbnailMaker component for creating thumbnails
 */
export function ThumbnailMaker() {
  const { state } = useThumbnailMaker();
  const { showEditor, showToolbar, showPanel } = state;

  // Container chính luôn chiếm toàn bộ không gian có sẵn
  const containerStyle = {
    height: '100%',
    display: 'flex',
    overflow: 'hidden', // Ngăn chặn scroll do nội dung
  };

  // Style cho container của toolbar
  const toolbarContainerStyle = {
    width: '250px', 
    minWidth: '250px',
    maxWidth: '250px',
    height: '100%',
    borderRight: '1px solid #eee',
    flexShrink: 0, // Không co lại khi thiếu không gian
  };

  // Style cho container của editor
  const editorContainerStyle: React.CSSProperties = {
    flex: 1,
    height: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
  };

  // Style cho container của danh sách items
  const itemsListContainerStyle = {
    width: '100%',
    maxWidth: '800px',
    marginTop: '10px',
    marginBottom: '20px',
  };

  // Style cho container của panel
  const panelContainerStyle = {
    width: '300px',
    minWidth: '300px',
    maxWidth: '300px',
    height: '100%',
    borderLeft: '1px solid #eee',
    flexShrink: 0, // Không co lại khi thiếu không gian
  };

  return (
    <Container fluid p={0} style={{ height: '100%' }}>
      <div style={containerStyle}>
        {showToolbar && (
          <div style={toolbarContainerStyle}>
            <Toolbar />
          </div>
        )}
        
        {showEditor && (
          <div style={editorContainerStyle}>
            <Editor />
            <div style={itemsListContainerStyle}>
              <ItemsList />
            </div>
          </div>
        )}
        
        {showPanel && (
          <div style={panelContainerStyle}>
            <EditorPanel />
          </div>
        )}
      </div>
    </Container>
  );
} 